import { render, staticRenderFns } from "./YA_FewShotContent1.vue?vue&type=template&id=a2b427c2&scoped=true"
import script from "./YA_FewShotContent1.vue?vue&type=script&lang=js"
export * from "./YA_FewShotContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b427c2",
  null
  
)

export default component.exports